"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedKey = void 0;
var bitcoinjs_lib_1 = require("bitcoinjs-lib");
var Mnemonic_1 = __importDefault(require("../../Handlers/Mnemonic"));
var PrivateKey_1 = require("./PrivateKey");
var PublicKey_1 = require("./PublicKey");
var Wallet_1 = require("../../Components/Wallet/Wallet");
var ExtendedKey = /** @class */ (function () {
    function ExtendedKey(node) {
        this.node = node;
    }
    ExtendedKey.fromMnemonic = function (mnemonic, type, account) {
        if (type === void 0) { type = "pub"; }
        if (account === void 0) { account = 0; }
        var seed = Mnemonic_1.default.mnemonicToSeed(mnemonic);
        // TODO: create zen network
        var extended = new ExtendedKey(bitcoinjs_lib_1.HDNode.fromSeedBuffer(seed));
        return type === "pub" ? extended.getZenPublicFromBase58(account) : extended;
    };
    ExtendedKey.fromBase58 = function (string) {
        return new ExtendedKey(bitcoinjs_lib_1.HDNode.fromBase58(string));
    };
    ExtendedKey.getZenPrivateKey = function (mnemonic, account, change, index) {
        return ExtendedKey.fromMnemonic(mnemonic, "pair").derivePath(new Wallet_1.Path(change, index).getFullZenPath(account)).getPrivateKey();
    };
    ExtendedKey.prototype.getZenPublicFromBase58 = function (account) {
        return ExtendedKey.fromBase58(this.derivePath("m/44'/258'/" + account + "'").neutered().toBase58());
    };
    ExtendedKey.prototype.derive = function (index) {
        return new ExtendedKey(this.node.derive(index));
    };
    ExtendedKey.prototype.deriveHardened = function (index) {
        return new ExtendedKey(this.node.deriveHardened(index));
    };
    ExtendedKey.prototype.derivePath = function (path) {
        return new ExtendedKey(this.node.derivePath(path));
    };
    ExtendedKey.prototype.neutered = function () {
        return new ExtendedKey(this.node.neutered());
    };
    ExtendedKey.prototype.getPrivateKey = function () {
        if (!this.node.keyPair.d) {
            throw new Error('no private key');
        }
        return new PrivateKey_1.PrivateKey(this.node.keyPair);
    };
    ExtendedKey.prototype.getPublicKey = function () {
        return PublicKey_1.PublicKey.deserialize(this.node.getPublicKeyBuffer());
    };
    ExtendedKey.prototype.getPublicKeyBuffer = function () {
        return this.node.getPublicKeyBuffer();
    };
    ExtendedKey.prototype.toAddress = function (chain) {
        return this.getPublicKey().toAddress(chain);
    };
    ExtendedKey.prototype.toBase58 = function () {
        return this.node.toBase58();
    };
    ExtendedKey.prototype.hasPrivateKey = function () {
        return this.node.keyPair.d !== undefined;
    };
    return ExtendedKey;
}());
exports.ExtendedKey = ExtendedKey;
//# sourceMappingURL=ExtendedKey.js.map